<template>
    <div class="container-bg1">
        <!-- 顶部导航工具栏 -->
        <!-- <div class="toolbar">
            <div class="toolbar-left">
                <van-icon name="arrow-left" size="20" />
                <span class="title">返回</span>
            </div>
            <div class="toolbar-right">
                <van-icon name="ellipsis" size="20" />
            </div>
        </div> -->

        <van-nav-bar fixed title="个人中心">
            <template #right>
                <van-popover v-if="user != null" v-model="showPopover" trigger="click" :actions="menuActions"
                    placement="bottom-end" @select="onMenuSelect">
                    <template #reference>
                        <van-icon name="ellipsis" size="24" />
                    </template>
                </van-popover>
            </template>
        </van-nav-bar>

        <!-- 内容区 -->
        <div class="content">
            <!-- 头像区 -->
            <div class="head-area myarea">
                <!-- 头像行 -->
                <van-row type="flex" class="img-row" @click="headRowClick">
                    <van-col span="5">
                        <van-image class="head-img" round fit="cover" width="50" height="50"
                            :src="'/img/headImg/' + _user.headImg" /></van-col>
                    <van-col span="15">
                        <div class="name font1">{{ _user.nickName }}<span>{{ _user.name }}</span></div>
                        <div class="gradient-radial money">
                            <span>🪙</span>
                            {{ _user.balance }}
                        </div>
                    </van-col>
                    <van-col span="4" class="col-center algin-right">
                        <van-icon name="arrow" />
                    </van-col>
                </van-row>
                <!-- 第二行 -->
                <div class="user-info-row">
                    <!-- 左侧方框 -->
                    <div class="user-info-left-area frame">
                        <div>
                            <van-icon name="location" color="#29DA00" />
                            我的推广码
                        </div>
                        <div style="margin-top: 10px; font-size: 14px; font-weight: 700;">{{ _user.id }}</div>
                    </div>
                    <!-- 右侧侧方框 -->
                    <div class="user-info-right-area frame">
                        <div>
                            <van-icon name="discount" color="#FF001E" />
                            我的提成比例
                        </div>
                        <div style="margin-top: 10px; font-size: 14px; font-weight: 700;">{{ _user.commissionRatio }}
                        </div>
                    </div>
                </div>
            </div>
            <!-- 广告区域 -->
            <div class="ad-area">
                <van-image class="head-img" fit="cover" width="100%" src="/img/ad/sign-ad.jpg" @click="signIn" />
            </div>
            <!-- 常用功能区 -->
            <div class="com-tool-area myarea">
                <h4>常用功能</h4>
                <van-grid :border="false">
                    <van-grid-item icon="pending-payment" to="/recharge" text="充值" />
                    <!-- <van-grid-item icon="paid" text="提现" /> -->
                    <van-grid-item icon="guide-o" text="邀请好友" @click="showShare = true" />
                    <van-grid-item icon="cluster-o" to="/children" text="下级管理" />
                    <van-grid-item icon="audio" to="/custom" text="联系客服" />
                </van-grid>
            </div>
            <!-- 更多功能区 -->
            <div class="com-tool-area myarea">
                <h4>更多功能</h4>
                <van-grid :border="false" :column-num="4">
                    <van-grid-item icon="balance-list" text="账户明细" to="/account" class="color2" />
                    <van-grid-item icon="newspaper" text="我的帖子" to="/mypost" class="color1" />
                    <van-grid-item icon="comment" text="我的评论" to="/myremark" class="color2" />
                    <van-grid-item icon="star" text="收藏" to="/collect" class="color4" />
                    <van-grid-item icon="like" text="点赞" to="/like" class="color4" />
                    <van-grid-item icon="records" text="个人资料" to="/useredit" class="color3" />
                    <van-grid-item icon="setting" text="安全中心" to="/security" class="color4" />
                    <!-- <van-grid-item icon="audio" text="测试" to="/test" class="color2" /> -->
                    <van-grid-item icon-prefix="my-icon" icon="tuichu" text="退出" class="color3" @click="loginOut" />
                </van-grid>
            </div>
        </div>

        <!-- 分享面板 -->
        <van-share-sheet v-model="showShare" title="立即分享给好友" :options="options" @select="onSelect" />
    </div>
</template>

<script>
import { auth, user as userApi } from '@/api';
import { mapState } from 'vuex';
import { qrcode } from '@/api';
import { Toast } from 'vant';
import { saveUserInfo } from '@/utils/request';
export default {
    name: 'Mine',
    data() {
        return {
            showShare: false,
            options: [
                { name: '微信', icon: 'wechat' },
                { name: '微博', icon: 'weibo' },
                { name: '复制链接', icon: 'link' },
                { name: '分享海报', icon: 'poster' },
                { name: '二维码', icon: 'qrcode' },
            ],
            showPopover: false,
            menuActions: [
                { text: '个人资料', icon: 'contact' },
                { text: '设置', icon: 'setting' },
                { text: '退出登录', icon: 'revoke' },
            ],
        };
    },
    async created() {
        // 进入页面后重新刷新用户信息，刷新的结果要更新localstorage和vuex
        const res = await userApi.refreshUserInfo()
        // console.log('res', res)
        saveUserInfo(res)
    },
    computed: {
        ...mapState('login', ['user']),
        headImg() {
            return '/img/headImg/' + (this.user?.headImg || '0.png')
        },
        _user() {
            return this.user || {
                id: '-',
                nickName: '登录/注册',
                headImg: '0.png',
                balance: 0,
                commissionRatio: '-'
            }
        },
    },
    methods: {
        onMenuSelect(action) {
            // debugger;
            // 处理菜单点击事件
            console.log('选中了:', action);
            this.showPopover = false; // 关闭菜单
            // 根据 action.text 或 action.index 跳转或执行其他操作
            switch (action.text) {
                case '个人资料':
                    this.$router.push('/useredit');
                    break;
                case '设置':
                    this.$router.push('/security');
                    break;
                case '退出登录':
                    this.loginOut();
                    break;
            }
        },

        // 签到
        signIn() {
            this.$notify({
                type: 'success',
                message: '开发中，敬请期待'
            })
        },

        // 分享海报
        async generateAndDownloadPoster() {
            try {
                // 1. 创建画布
                const canvas = document.createElement('canvas');
                canvas.width = 750;
                canvas.height = 1125;
                const ctx = canvas.getContext('2d');

                // 2. 加载背景图（先加载，确保后续绘制都在上面）
                const background = new Image();
                background.crossOrigin = 'anonymous';
                background.src = '/img/poster/background.jpg'; // 你的背景图路径
                await new Promise((resolve, reject) => {
                    background.onload = resolve;
                    background.onerror = reject;
                });

                // 3. 绘制背景图（铺满整个画布）
                ctx.drawImage(background, 0, 0, canvas.width, canvas.height);

                // 4. 绘制用户头像（在背景之上）
                const avatar = new Image();
                avatar.crossOrigin = 'anonymous';
                avatar.src = '/img/headImg/' + this.user.headImg;
                await new Promise(resolve => {
                    avatar.onload = resolve;
                });

                /**
参数	    类型	    说明	                            示例值
x	        Number	    圆心的 x 坐标（相对于画布左上角）	  375
y	        Number	    圆心的 y 坐标（相对于画布左上角）	  200
radius	    Number	    圆的半径（像素）	                 80
startAngle	Number	    起始角度（弧度制）	                 0
endAngle	Number	    结束角度（弧度制）	                 Math.PI * 2
                 */
                // 定义头像参数
                const avatarCenterX = 385;      // 头像中心 x
                const avatarCenterY = 100;      // 头像中心 y（调整这个值）
                const avatarRadius = 60;        // 头像半径
                const avatarSize = 120;          // 头像尺寸

                // 计算左上角坐标
                const avatarX = avatarCenterX - avatarRadius;  // 295
                const avatarY = avatarCenterY - avatarRadius;  // 100
                // 绘制头像（圆形裁剪）
                ctx.save();
                ctx.beginPath();
                // ctx.arc(375, 200, 80, 0, Math.PI * 2);
                ctx.arc(avatarCenterX, avatarCenterY, avatarRadius, 0, Math.PI * 2);
                ctx.closePath();
                ctx.clip();
                // ctx.drawImage(avatar, 295, 20, 160, 160);
                ctx.drawImage(avatar, avatarX, avatarY, avatarSize, avatarSize);
                ctx.restore();

                /**
参数	    类型	            说明	                        示例值
image	    Image/Canvas/Video	要绘制的图像对象	            qrCode
x	        Number	            图像左上角在画布中的 x 坐标	    275
y	        Number	            图像左上角在画布中的 y 坐标	    500
width	    Number	            绘制到画布上的宽度（像素）	    200
height	    Number	            绘制到画布上的高度（像素）	    200
                 */
                // 5. 绘制用户昵称
                ctx.fillStyle = '#ffffff';
                ctx.font = 'bold 36px Arial';
                ctx.textAlign = 'center';
                ctx.fillText(this.user.nickName, 385, 200);

                // 6. 绘制推广码
                const qrCode = new Image();
                qrCode.crossOrigin = 'anonymous';
                qrCode.src = await qrcode.getQRCodeBase64({
                    width: 200,
                    height: 200
                })
                await new Promise(resolve => {
                    qrCode.onload = resolve;
                });
                ctx.drawImage(qrCode, 285, 840, 200, 200);

                // // 7. 转换为图片并下载
                // const imageUrl = canvas.toDataURL('image/png');
                // const link = document.createElement('a');
                // link.href = imageUrl;
                // link.download = `海报_${this.user.nickName}.png`;
                // document.body.appendChild(link);
                // link.click();
                // document.body.removeChild(link);

                // this.$toast.success('您的推广海报已保存');

                const imageUrl = canvas.toDataURL('image/png');

                // 判断环境并处理
                const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
                const isWechat = typeof WeixinJSBridge !== 'undefined';

                Toast.clear();

                if (isWechat) {
                    // 微信环境：调用微信保存相册
                    WeixinJSBridge.invoke('saveImageToPhotosAlbum', {
                        imgUrl: imageUrl
                    }, (res) => {
                        if (res.err_msg === 'saveImageToPhotosAlbum:ok') {
                            Toast.success('已保存到相册');
                        } else {
                            Toast.fail('保存失败，请长按保存');
                            this.showImagePreview(imageUrl);
                        }
                    });
                } else if (isMobile) {
                    // 普通移动端：预览 + 长按保存
                    this.showImagePreview(imageUrl);
                } else {
                    // PC端：直接下载
                    this.downloadImage(imageUrl);
                }

            } catch (err) {
                console.error('生成海报失败', err);
                this.$toast.fail('生成海报失败');
            }
        },

        // 二维码
        async downloadQrCode() {
            try {
                // 1. 创建画布
                const canvas = document.createElement('canvas');
                canvas.width = 300;
                canvas.height = 300;
                const ctx = canvas.getContext('2d');

                // 6. 绘制推广码
                const qrCode = new Image();
                qrCode.crossOrigin = 'anonymous';
                qrCode.src = await qrcode.getQRCodeBase64({
                    width: 300,
                    height: 300
                })
                await new Promise(resolve => {
                    qrCode.onload = resolve;
                });
                ctx.drawImage(qrCode, 0, 0, 300, 300);

                // // 7. 转换为图片并下载
                // const imageUrl = canvas.toDataURL('image/png');
                // const link = document.createElement('a');
                // link.href = imageUrl;
                // link.download = `二维码_${this.user.nickName}.png`;
                // document.body.appendChild(link);
                // link.click();
                // document.body.removeChild(link);

                // this.$toast.success('您的推广二维码已保存');

                const imageUrl = canvas.toDataURL('image/png');

                // 判断环境并处理
                const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
                const isWechat = typeof WeixinJSBridge !== 'undefined';

                Toast.clear();

                if (isWechat) {
                    // 微信环境：调用微信保存相册
                    WeixinJSBridge.invoke('saveImageToPhotosAlbum', {
                        imgUrl: imageUrl
                    }, (res) => {
                        if (res.err_msg === 'saveImageToPhotosAlbum:ok') {
                            Toast.success('已保存到相册');
                        } else {
                            Toast.fail('保存失败，请长按保存');
                            this.showImagePreview(imageUrl);
                        }
                    });
                } else if (isMobile) {
                    // 普通移动端：预览 + 长按保存
                    this.showImagePreview(imageUrl);
                } else {
                    // PC端：直接下载
                    this.downloadImage(imageUrl);
                }

            } catch (err) {
                console.error('生成二维码失败', err);
                this.$toast.fail('生成二维码失败');
            }
        },

        // 复制方法
        async copyLink(linkToShare) {
            try {
                await navigator.clipboard.writeText(linkToShare);
                this.$toast.success('链接已复制');
            } catch (err) {
                // 降级方案：使用传统的 execCommand 方法 [citation:8]
                const input = document.createElement('input');
                input.value = linkToShare;
                document.body.appendChild(input);
                input.select();
                document.execCommand('copy');
                document.body.removeChild(input);
                this.$toast.success('链接已复制');
            }
        },

        // 微信、微博分享
        async shareToSocial(linkToShare) {
            // 检查浏览器是否支持 Web Share API [citation:7][citation:10]
            if (navigator.share) {
                try {
                    await navigator.share({
                        title: '彩神论坛',
                        text: '精准推荐 · 数据分析 · 专家排名 · 智能选号',
                        url: linkToShare,
                    });
                    this.$toast.success('分享成功');
                } catch (err) {
                    if (err.name !== 'AbortError') {
                        this.$toast.fail('分享取消或失败');
                    }
                }
                this.showShare = false;
                return;
            }
            this.$toast.fail('暂不支持该功能');
        },

        // 分享按钮
        async onSelect(option) {
            let linkToShare = window.location.href.replace('/mine', '/register'); // 要分享的链接
            if (this.user) {
                linkToShare += '?id=' + this.user.id;
            } else {
                Toast('请先登录')
                this.$router.replace('/login')
                return
            }
            switch (option.name) {
                case '复制链接':
                    this.copyLink(linkToShare);
                    break;
                case '分享海报':
                    this.generateAndDownloadPoster();
                    break;
                case '二维码':
                    this.downloadQrCode();
                    break;
                case '微信':
                case '微博':
                    this.shareToSocial(linkToShare);
                    break;
            }
            this.showShare = false;
        },

        // 登出
        async loginOut() {
            await auth.logout()
            auth.clearToken()
            this.$router.replace('/login')
        },

        // 头部行点击事件
        headRowClick() {
            if (this.user) {
                // 去编辑页
                this.$router.push('/useredit')
            } else {
                this.$router.replace({
                    path: '/login',
                    query: { redirectUrl: '/mine' }
                })
            }
        },



        // ===== 新增兼容移动端和微信的图片保存功能 =====
        // 显示图片预览（移动端长按保存）
        showImagePreview(imageUrl) {
            // 如果已经有预览，先移除
            const existingOverlay = document.querySelector('.poster-preview-overlay');
            if (existingOverlay) {
                document.body.removeChild(existingOverlay);
            }

            const overlay = document.createElement('div');
            overlay.className = 'poster-preview-overlay';
            overlay.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.92);
        z-index: 99999;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 20px;
        animation: fadeIn 0.3s ease;
    `;

            // 添加动画样式
            const style = document.createElement('style');
            style.textContent = `
        @keyframes fadeIn {
            from { opacity: 0; transform: scale(0.9); }
            to { opacity: 1; transform: scale(1); }
        }
    `;
            document.head.appendChild(style);

            // 图片
            const img = document.createElement('img');
            img.src = imageUrl;
            img.style.cssText = `
        max-width: 100%;
        max-height: 70vh;
        border-radius: 8px;
        box-shadow: 0 4px 30px rgba(0,0,0,0.5);
        user-select: none;
        -webkit-user-select: none;
    `;

            // 提示文字
            const tip = document.createElement('div');
            tip.textContent = '📱 长按图片保存到相册';
            tip.style.cssText = `
        color: rgba(255,255,255,0.8);
        font-size: 14px;
        margin-top: 16px;
        letter-spacing: 1px;
    `;

            // 关闭按钮
            const closeBtn = document.createElement('button');
            closeBtn.textContent = '✕ 关闭';
            closeBtn.style.cssText = `
        margin-top: 20px;
        padding: 10px 40px;
        background: rgba(255,255,255,0.15);
        color: #fff;
        border: 1px solid rgba(255,255,255,0.3);
        border-radius: 25px;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.3s;
    `;
            closeBtn.onmouseover = () => {
                closeBtn.style.background = 'rgba(255,255,255,0.25)';
            };
            closeBtn.onmouseout = () => {
                closeBtn.style.background = 'rgba(255,255,255,0.15)';
            };
            closeBtn.onclick = () => {
                document.body.removeChild(overlay);
                document.head.removeChild(style);
            };

            overlay.appendChild(img);
            overlay.appendChild(tip);
            overlay.appendChild(closeBtn);
            document.body.appendChild(overlay);

            // 点击背景关闭
            overlay.addEventListener('click', (e) => {
                if (e.target === overlay) {
                    document.body.removeChild(overlay);
                    document.head.removeChild(style);
                }
            });
        },

        // PC端下载
        downloadImage(imageUrl) {
            const link = document.createElement('a');
            link.href = imageUrl;
            link.download = `海报_${new Date().getTime()}.png`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            Toast.success('海报已下载');
        },

    },
}
</script>

<style scoped>
.content {
    padding: 56px 16px 60px 16px;
}

::v-deep .color1 .van-grid-item__icon {
    color: #009696;
    font-size: 40px;
}

::v-deep .color2 .van-grid-item__icon {
    color: #c1ce08;
    font-size: 40px;
}

::v-deep .color3 .van-grid-item__icon {
    color: #9010ff;
    font-size: 40px;
}

::v-deep .color4 .van-grid-item__icon {
    color: #ff3030;
    font-size: 40px;
}

.img-row {
    height: 51px;
}

.myarea {
    border-radius: 8px;
    background: #fff;
    padding: 16px;
    min-height: 30px;
    margin-bottom: 10px;
}

.myarea h4 {
    color: #6A6A6A;
    font-size: 12px;
    margin-bottom: 10px;
}

.ad-area {
    border-radius: 8px;
    background: #fff;
    margin-bottom: 10px;
    overflow: hidden;
}

.name {
    height: 24px;
    line-height: 24px;
}

.name span {
    margin-left: 5px;
    font-size: 11px;
    color: #A6A6A6;
}

/* 径向渐变 */
.gradient-radial {
    min-width: 40px;
    max-width: 50px;
    height: 18px;
    line-height: 17px;
    background: radial-gradient(circle, #ff7e5f, #ffcaa1);
    border-radius: 9px;
    margin-top: 5px;
    position: relative;
    padding-left: 22px;
    color: #fff;
    font-size: 12px;
}

.gradient-radial span {
    position: absolute;
    left: -6px;
    top: -2px;
    font-size: 22px;
}

.user-info-row {
    height: 60px;
    margin-top: 16px;
}

.frame {
    border: 1px solid #E6E6E6;
    border-radius: 6px;
    width: 42%;
    height: 40px;
    padding: 10px;
    font-size: 13px;
}

.user-info-left-area {
    float: left;
}

.user-info-right-area {
    float: right;
}

/* 顶部工具导航栏样式开始 */
.toolbar {
    position: sticky;
    top: 0;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    background: linear-gradient(to bottom, #FEECEB 0,
            #F3F3F3 100vh);
    color: #202020;
}

.toolbar-left {
    display: flex;
    align-items: center;
    gap: 12px;
}

.toolbar-left .title {
    font-size: 18px;
    font-weight: 600;
}

.toolbar-right {
    display: flex;
    align-items: center;
    gap: 20px;
}

.toolbar-right .van-icon {
    cursor: pointer;
}

/* 顶部工具导航栏样式结束 */
</style>